import { StoreonModule } from "storeon"

export interface ISidebarStore {
  sidebarStore: {
    activeStep: number,
    hasCompleteEligibility: boolean,
    hasCompleteSubscriberInfo: boolean,
    hasCompleteDependentInfo: boolean,
    hasReviewedSelections: boolean
  }
}

export interface ISidebarEvents {
  setActiveStep: any;
  setHasCompleteEligibility: any;
  setHasCompleteSubscriberInfo: any;
  setHasCompleteDependentInfo: any;
  setHasReviewedSelections: any;
}

const sidebarStore: StoreonModule<ISidebarStore, ISidebarEvents>= (store) => {
  store.on('@init', () => ({
    sidebarStore: {
      activeStep: 1,
      hasCompleteEligibility: false,
      hasCompleteSubscriberInfo: false,
      hasCompleteDependentInfo: false,
      hasReviewedSelections: false
    }
  }))

  store.on('setActiveStep', ({ sidebarStore }, activeStep) => {
    sidebarStore.activeStep = activeStep
    return { sidebarStore }
  })

  store.on('setHasCompleteEligibility', ({ sidebarStore }, hasCompleteEligibility) => {
    sidebarStore.hasCompleteEligibility = hasCompleteEligibility
    return { sidebarStore }
  })

  store.on('setHasCompleteSubscriberInfo', ({ sidebarStore }, hasCompleteSubscriberInfo) => {
    sidebarStore.hasCompleteSubscriberInfo = hasCompleteSubscriberInfo
    return { sidebarStore }
  })

  store.on('setHasCompleteDependentInfo', ({ sidebarStore }, hasCompleteDependentInfo) => {
    sidebarStore.hasCompleteDependentInfo = hasCompleteDependentInfo
    return { sidebarStore }
  })

  store.on('setHasReviewedSelections', ({ sidebarStore }, hasReviewedSelections) => {
    sidebarStore.hasReviewedSelections = hasReviewedSelections
    return { sidebarStore }
  })
}

export default sidebarStore;